import type { FaireProductEntity } from "../../entity_types/product";

export const p_8kn2ye5p2g: FaireProductEntity = {
  token: "p_8kn2ye5p2g",
  type: "product",
  name: "Blackberry Lemon Sleep Drink Mix: Magnesium & Melatonin",
  brandToken: "b_zngvnr6fff",
  brandName: "Rookie Wellness",
  imageUrl:
    "https://cdn.faire.com/fastly/87a30d2041114d60dbe5df8848c9c65460fc5ae1e0f3d8dcd0fd81a010f03f21.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b47365767e6582fc66e20c4d93c2e82371fffc50288f805f819c06fa109f1a8f.png",
    "https://cdn.faire.com/fastly/b1fd4e07ef5febc2ca4cde835d48572eb4021d957fd3a9179c07d3b89a02c572.png",
    "https://cdn.faire.com/fastly/4dd91a2468888d3cc7d7a6e49a2d5d70ac3e74e3a948937d08a9ce71935b7af6.png",
    "https://cdn.faire.com/fastly/88a66be6c03367513779a1b6b6fac1fbc437679f2199fcb4b62c8e81c88c4a42.png",
    "https://cdn.faire.com/fastly/890a991ced1c70f9584fb96ede8a2303d2e3cd485b3b8be7534c0385598dc4e8.png",
  ],
  priceDollars: 14.99,
  description:
    "Rookie Wellness’ Blackberry Lemon Sleep Drink Mix is a calming powder blend made with magnesium bisglycinate, low-dose melatonin, valerian root, and passion flower to support restful sleep—without the grogginess. Each single-serve stick delivers 180mg of magnesium to aid relaxation, digestion, and plus 1mg of melatonin to help regulate sleep cycles. Just stir into 10–12 oz of cold water and sip 30 minutes before bed.\n\nFounded by a full-time working mom, Rookie is redefining wellness by making it approachable and inclusive for all—empowering both beginners and enthusiasts to take control of their well-being.\n\n🍋 180mg magnesium, 1mg melatonin, 0g sugar\n🍋 Blackberry Lemon flavor: calming and light\n🍋 Supports: sleep, anxiety relief, and calm digestion\n🍋 Shelf-stable: ideal for wellness kits or bedtime bundles\n🍋 Case pack: 6 units, 14 travel-sized packets per unit\n\nStock this to offer clean sleep support that helps customers wind down and wake up refreshed.",
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:46.193Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
